module.exports = __webpack_public_path__ + "static/media/link_parallel.1932af14.webp";